import React from 'react';
import AccountList from './AccountList';
import '../../styles/Panel.css';

const Accounts = () => {
  return (
    <div className="container">
    <div className="columns is-multiline">
        <div className="column is-12" style={{ flexShrink: 0 }}>
            <AccountList />
        </div>
    </div>
</div>

  );
};

export default Accounts;
